import React from 'react';
import { useNavigate } from 'react-router-dom';
import { removeCookies } from '../../services/Cookies.jsx';
import toast, { toast as toastManager } from 'react-hot-toast';
import api from '../../api/index.js';
import { useDispatch } from 'react-redux';
import { setloggedIn } from "../../store/slices/userSlice.js";

let errorToastId = null;
const showErrorToast = (message) => {
    if (errorToastId) {
        return;
    }
    errorToastId = toast.error(message, {
        // duration: 4000, // Customize the duration as needed
        onClose: () => {
            // Reset the errorToastId when the toast is closed
            errorToastId = null;
        }
    });
};
export default function SessionManager() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    api.interceptors.response.use(
        response => {
            return response;
        },

        error => {
        
            if (error.response.status === 401) {
                dispatch(setloggedIn(false));
                removeCookies('token');
                showErrorToast('Your session has expired. Please login to pick up where you left off.');
                return navigate('/');
            }

            if (error.response.status === 503) {
                return navigate('/maintenance');
            }
           
            
            return Promise.reject(error);
        }
    );
}